import DropZone from "./components/Dropzone.svelte";

export default DropZone;
